import script from "./encountersList.vue?vue&type=script&setup=true&lang=js"
export * from "./encountersList.vue?vue&type=script&setup=true&lang=js"

import "./encountersList.vue?vue&type=style&index=0&id=381b2ec1&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-381b2ec1"]])

export default __exports__